<template>
  <div class="rule-wrap">
    <div class="content-wrap">
      <div class="content">
        <div class="info-wrap">
          <img class="avtor" :src="$store.getters.getUser?.avatar" alt="" />
          <div class="text-wrap">
            <p>齐鲁文化参赛者 {{ $store.getters.getUser?.nickname }}</p>
            <p>最快用时 {{ formatDuring(user?.longTime) }}</p>
          </div>
        </div>
        <div class="rank-info">
          <p class="flex">
            <span>答对题数 {{ user?.rightCount }} 题</span>
            <span>通关次数 {{ user?.completeTime || 0 }} 次</span>
          </p>
          <p>
            <span>当前排名 {{ user?.rowNum }} 名</span>
          </p>
        </div>
        <ul class="record-list">
          <List
            v-model:loading="state.loading"
            :finished="state.finished"
            finished-text="没有更多了"
            @load="fecthData"
          >
            <li
              v-for="(item, index) in state.list"
              :key="index"
              class="list-item"
            >
              <div class="text-wrap">
                <span class="label">答题时间：</span>
                <span class="value">{{ item.createTime }}</span>
              </div>
              <div class="text-wrap">
                <span class="label">答对题数：</span>
                <span class="value">{{ item.rightCount || 0 }} 题</span>
              </div>
              <div class="text-wrap">
                <span class="label">答题时长：</span>
                <span class="value">{{ formatDuring(item.longTime) }}</span>
              </div>
              <img
                v-if="item.isFast === 1"
                src="@/assets/img/sdws/fast-time.png"
                alt=""
              />
            </li>
          </List>
        </ul>
      </div>
    </div>
  </div>
  <div class="mask"></div>
  <img
    @click="$router.go(-1)"
    class="back-btn"
    src="@/assets/img/sdws/back.png"
    alt=""
  />
</template>

<script setup>
import { useCommonUserRankInfoEffect } from '@/effects/sdwsEffect.js'
import { getUserRecordList } from '@/api/sdws.js'
import { reactive } from '@vue/reactivity'
import { useRoute } from 'vue-router'
import { List } from 'vant'
import { formatDuring } from '@/utils/tools'
import { useStore } from 'vuex'

// 获取答题记录
const route = useRoute()
const store = useStore()

const state = reactive({
  list: [],
  loading: false,
  finished: false,
})

const queryList = {
  pageNo: 0,
  pageSize: 10,
  total: 0,
}

const fecthData = async () => {
  queryList.pageNo++
  const res = await getUserRecordList({
    questionActiveKey: route.query.questionActiveKey,
    pageNo: queryList.pageNo,
    pageSize: queryList.pageSize,
    token: store.getters.getToken,
  })

  if (res.ok) {
    state.list = [...state.list, ...res.data.rows]
    queryList.total = res.data.total

    state.loading = false
    if (state.list.length >= res.data.total) {
      state.finished = true
    }
  }
}

const { user } = useCommonUserRankInfoEffect()
</script>

<style scoped lang="scss">
.rule-wrap {
  width: 100%;
  min-height: 100vh;
  background: no-repeat center/100%
    url('../../../assets/img/sdws/content-bg.png');

  .content-wrap {
    box-sizing: border-box;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    padding: 0 24px;
    padding-top: 80px;
    width: 690px;
    height: 1128px;
    background: no-repeat 100% url('../../../assets/img/sdws/book-bg.png');
    z-index: 2;
    overflow-y: scroll;

    .content {
      border-top: 2px solid #b88642;
      border-bottom: 2px solid #b88642;
      height: 298px;

      .info-wrap {
        display: flex;
        margin-top: 28px;
        .avtor {
          margin-right: 28px;
          width: 112px;
          height: 110px;
          border-radius: 50%;
          border: 2px solid #8b5e2f;
        }

        .text-wrap {
          margin-top: 16px;
          p {
            font-size: 32px;
            font-family: SourceHanSansCN-Regular, SourceHanSansCN;
            font-weight: 400;
            color: #8b5e2f;

            &:last-child {
              margin-top: 20px;
            }
          }
        }
      }

      .rank-info {
        font-size: 32px;
        font-family: SourceHanSansCN-Regular, SourceHanSansCN;
        font-weight: 400;
        color: #8b5e2f;

        p {
          margin-top: 24px;
        }

        p.flex {
          display: flex;
          justify-content: space-between;
        }
      }

      .record-list {
        margin-top: 120px;
        padding-bottom: 60px;
        ::v-deep {
          .van-loading__text,
          .van-loading {
            color: #b88642;
          }
          .van-list__finished-text {
            color: #b88642;
          }
        }
        .list-item {
          position: relative;
          box-sizing: border-box;
          padding: 38px;
          margin-top: 16px;
          width: 640px;
          height: 256px;
          border-radius: 8px;
          border: 2px solid #8c5f30;

          .text-wrap {
            margin-bottom: 40px;
            font-size: 0;
            .label {
              font-size: 32px;
              font-family: SourceHanSansCN-Regular, SourceHanSansCN;
              font-weight: 400;
              color: #401913;
            }

            .value {
              margin-left: 30px;
              font-size: 32px;
              font-family: SourceHanSansCN-Regular, SourceHanSansCN;
              font-weight: 400;
              color: #8b5e2f;
            }
          }

          img {
            position: absolute;
            top: 38px;
            right: 22px;
            width: 206px;
            height: 182px;
          }
        }
      }
    }
  }
}
.mask {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba($color: #000000, $alpha: 0.6);
}
</style>
